module.exports = __webpack_public_path__ + "static/img/peixunactive.de4d79f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/peixunactive.png
// module id = AaPp
// module chunks = 34